import { Image, ImageProps } from "@chakra-ui/image";
import { motion } from "framer-motion";

export const MotionImg = motion<ImageProps>(Image);
